var PaginationView = require('./PaginationView');
var routerUtils = require('./../utils/routerUtils');

/**
 * This view renders a pagination list, but uses hash query parameters for the page numbers.
 * The view is 1-indexed
 * @class QueryParamPaginationView.js
 * @constructor
 * @extends PaginationView
 */
module.exports = PaginationView.extend({
  /**
   * @property _pageParamName {String} the name of the page parameter in the query parameters.
   */
  _pageParamName: 'page',

  /**
   * @override
   * @param [options={}] {Object} the options for this view.
   *   @param [options.pageParamName='page'] {String} the name of the query parameter to use for the page number.
   */
  initialize: function(options) {
    options = options || {};
    PaginationView.prototype.initialize.apply(this, arguments);
    this._pageParamName = options.pageParamName || this._pageParamName;
  },

  /**
   * Returns the root url without the page query parameter but it will keep other query parameters.
   * @private
   * @method  _getRootHashWithoutPage
   * @return {String} The current url stripped of hash query variables
   * @example
   *   '#bills?page=1' returns '#bills'
   * @example
   *   '#bills?page=1,other=true' returns '#bills?other=true'
   * @example
   *   '#bills/list?page=1' returns '#bills/list'
   */
  _getRootHashWithoutPage: function() {
    var currLocation = window.location.href;
    return routerUtils.addQueryParameterToHash(this._pageParamName, null, currLocation);
  },

  /**
   * Extension point for views that want to handle pagination differently.
   * @method _redirectToPage
   * @param clickedLink {jQuery.Selector} the link that was clicked wrapped using jQuery.
   * @private
   */
  _redirectToPage: function(clickedLink) {
    var newPage = clickedLink.attr('page');
    var currLocation = window.location.href;
    var newLocation = routerUtils.addQueryParameterToHash(this._pageParamName, newPage, currLocation);
    window.location = routerUtils.cleanRedirectURL(newLocation);
  }
});
